// pwa-src/components/cards/playerCards/v2/AttributeSets.ts
import { Attribute, Zones } from "@alienheadwars/football-card-manager-model";

// Includes 'shoot' - relevant for MIDFIELD and ATTACK zones
export const ATTACKING_ATTRIBUTES_FULL: Attribute[] = ['shoot', 'pass', 'run'];

// Excludes 'shoot' - relevant for DEFENSE zone when attacking
export const ATTACKING_ATTRIBUTES_NO_SHOOT: Attribute[] = ['pass', 'run'];

export const ALL_ATTRIBUTES:Attribute[] = ['shoot', 'pass', 'run', 'tackle', 'block', 'intercept'];


// --- Defensive Attribute Sets ---

// Includes 'block' - relevant for DEFENSE zone
export const DEFENSIVE_ATTRIBUTES_FULL: Attribute[] = ['tackle', 'block', 'intercept'];

// Excludes 'block' - relevant for MIDFIELD and ATTACK zones when defending
export const DEFENSIVE_ATTRIBUTES_NO_BLOCK: Attribute[] = ['tackle', 'intercept']

/**
 * Gets the attacking attributes relevant for the current zone.
 * 'shoot' is only included in MIDFIELD or ATTACK zones.
 * @param zone The current zone of play.
 * @returns An array of relevant attacking attributes.
 */
export const getAttackingAttributes = (zone: Zones): Attribute[] => {
    if (zone !== Zones.MIDFIELD && zone !== Zones.ATTACK) {
        return (ATTACKING_ATTRIBUTES_NO_SHOOT);
    }
    return ATTACKING_ATTRIBUTES_FULL;
};


/**
 * Gets the defensive attributes relevant for the current zone.
 * 'block' is only included in the DEFENSE zone.
 * @param zone The current zone of play.
 * @returns An array of relevant defensive attributes.
 */
export const getDefensiveAttributes = (zone: Zones): Attribute[] => {
    if (zone !== Zones.ATTACK) {
        return   DEFENSIVE_ATTRIBUTES_NO_BLOCK
    }
    return DEFENSIVE_ATTRIBUTES_FULL;
};
